import bowser from "bowser";
import connectToStores from "alt-utils/lib/connectToStores";
import size from "lodash/size";
import noop from "lodash/noop";
import PropTypes from "prop-types";
import React, { Component } from "react";

import { ANDROID_KEYBOARD_SLIDE_ANIMATION_DURATION, PostMessage } from "../../constants/chat";
import AskFormStore from "../../stores/chat/AskFormStore";
import ChatActions from "../../actions/ChatActions";
import ConfigStore from "../../stores/chat/ConfigStore";
import { postMessageToParent } from "../../utils/Utils";

export class AskQuestionFormContactInfoInput extends Component {
    constructor() {
        super();

        this.onBlur = this.onBlur.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onFocus = this.onFocus.bind(this);
    }

    static getPropsFromStores() {
        return {
            isValid: AskFormStore.isContactInfoValid(),
            isVisible: AskFormStore.shouldDisplayContactInfo(),
            value: AskFormStore.getState().contactInfo,
        };
    }

    static getStores() {
        return [AskFormStore, ConfigStore];
    }

    onBlur() {
        if (bowser.android) {
            document.body.style.height = "";
            postMessageToParent(PostMessage.SET_HEIGHT, { height: this.props.askFormHeight });
        }
    }

    onFocus({ target }) {
        if (bowser.android) {
            document.body.style.height = "auto";
            postMessageToParent(PostMessage.SET_HEIGHT, { height: "100%" });
            setTimeout(() => {
                target.scrollIntoViewIfNeeded(true);
            }, ANDROID_KEYBOARD_SLIDE_ANIMATION_DURATION);
        }
    }

    onChange({ target: { value } }) {
        ChatActions.updateContactInfo(value);
    }

    render() {
        const {
            allowQuestionSignupWithPhoneNumber,
            disabled,
            isValid,
            isVisible,
            label,
            setRef,
            shouldDisplayError,
            value,
        } = this.props;
        const placeholder = allowQuestionSignupWithPhoneNumber
            ? i18n.t("rtm.placeholder.type_your_email_or_phone")
            : i18n.t("rtm.placeholder.type_your_email_address");

        return isVisible ? (
            <div className="input-group">
                {label && (
                    <label htmlFor="email">
                        <strong>{label}</strong>
                    </label>
                )}
                <input
                    disabled={disabled}
                    id="email"
                    onBlur={this.onBlur}
                    onChange={this.onChange}
                    onFocus={this.onFocus}
                    placeholder={placeholder}
                    ref={setRef}
                    type="email"
                    value={value}
                />
                {!isValid && shouldDisplayError && (
                    <span className="error">
                        {size(value) > 0
                            ? i18n.t("rtm.error.please_provide_valid_contact_information")
                            : i18n.t("rtm.error.please_provide_your_contact_information")}
                    </span>
                )}
            </div>
        ) : null;
    }
}

AskQuestionFormContactInfoInput.defaultProps = {
    setRef: noop(),
    label: undefined,
};

AskQuestionFormContactInfoInput.propTypes = {
    allowQuestionSignupWithPhoneNumber: PropTypes.bool.isRequired,
    askFormHeight: PropTypes.string.isRequired,
    disabled: PropTypes.bool.isRequired,
    isValid: PropTypes.bool.isRequired,
    isVisible: PropTypes.bool.isRequired,
    label: PropTypes.string,
    setRef: PropTypes.func,
    shouldDisplayError: PropTypes.bool.isRequired,
    value: PropTypes.string.isRequired,
};

export default connectToStores(AskQuestionFormContactInfoInput);
